
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.9 23.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M20.7 2.5h-2.3v8h2.3v-8zm-16.1 0H2.3v8h2.3v-8zM22.9.2v10.3c0 .6-.3 1.2-.7 1.6-.4.4-1 .7-1.6.7h-2.5c-.6 2.8-2.4 4.3-5.5 4.6v2.4c.7.1 1.4.3 2 .8.4.3.8.7 1 1.1.2.3.3.7.4 1l.1.4H6.9l.1-.5c.1-.4.2-.7.4-1 .2-.5.6-.8 1-1.1.6-.4 1.3-.7 2-.8v-2.4c-3.1-.3-4.9-1.9-5.5-4.6H2.3c-.6 0-1.2-.3-1.6-.7-.4-.4-.7-1-.7-1.6V.2h4.6c.6 0 1.2.3 1.6.7.5.4.7.9.8 1.5h9c0-.6.3-1.1.8-1.5.4-.4 1-.7 1.6-.7h4.5z"}})])
          )
        }
      }
    